import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Notification } from "@lululemon/ecom-pattern-library-notification";

import styles from "./styles/inventory-notifications.module.scss";

const InventoryNotifications = ({
  notifications,
  notificationsRef,
  isStoreSelected
}) => {
  const hasActiveNotifications = notifications?.some((note) => note.visible);

  return (
    <div
      className={classNames({
        [styles.root]: hasActiveNotifications,
        "lll-hidden-visually": !hasActiveNotifications || !isStoreSelected
      })}
      ref={notificationsRef}
    >
      {notifications.map(({ id, type, children, visible }) => {
        return (
          <Notification key={id} id={id} type={type} visible={visible}>
            {children}
          </Notification>
        );
      })}
    </div>
  );
};

const NotificationProps = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["error", "warning"]).isRequired,
  visible: PropTypes.bool,
  children: PropTypes.node
});

InventoryNotifications.propTypes = {
  notifications: PropTypes.arrayOf(NotificationProps),
  ref: PropTypes.shape({ current: PropTypes.object }),
  isStoreSelected: PropTypes.bool
};

InventoryNotifications.defaultProps = {
  notifications: [],
  ref: undefined,
  isStoreSelected: false
};

export default React.memo(InventoryNotifications);
